export default "__VITE_ASSET__BB13tjrK__"